module.exports = __webpack_public_path__ + "static/media/mitnick.eda4c4de.gif";